<template>
  <div 
    class="subprogram-nba-form-page"
  >
    <!-- Back
      - Si venimos del form de emparejar por primera vez (routeName: SubprogramNbaSchoolTeamNew) al dar a back nos lleva a la ( routName: SubprogramNba {params: programid, subprogramId} )
      - Si venimos de la ruta de editar una school (routeName: SubprogramNbaSchoolTeamEdit) al dar a back nos lleva a la (routeName: SubprogramNbaSchoolTeamView {params: programid, subprogramId, teamId} ) 
    -->
    <app-back-button
      class="stripe-connected-account-form-page__header__back"
      :route-name="dynamicRoute.name"
      :route-params="dynamicRoute.params"
      i18n-code="entities.subprogram.nba.tabs.summary"
    />

    <!-- Title -->
    <h1 class="app-content-title">
      <app-i18n code="entities.subprogram.nba.school.editPair.title" v-if="isEditing" />
      <app-i18n code="entities.subprogram.nba.school.newPair.title" v-if="!isEditing" />
    </h1>

    <div class="app-content-page"
      v-loading="saveLoading"
    >
      <!-- Card Team -->
      <app-subprogram-nba-team-card
        :subpropertyId="subpropertyId"
        :programId="programId"
        :subprogramId="subprogramId"
        :teamId="teamId"
      />

      <!-- School form -->
      <app-school-form
        :doBackFn="doBack"
        :onSubmitFn="handleOnSubmitSchool"
        :id="schoolId"
      />
    </div>
  </div>
</template>
<script>

import SchoolForm from '@modules/school/components/school-form.vue';
import SubprogramNbaSchoolFormCard from '@modules/subprogram/nba/components/subprogram-nba-team-card.vue';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'app-subprogram-nba-form-page',

  props: {
    teamId: {
      type: String,
      required: true
    },
    programId: {
      type: String,
      required: true
    },
    subprogramId: {
      type: String,
      required: true
    },
    schoolId: {
      type: String
    }
  },

  computed: {
    ...mapGetters({
      saveLoading: 'subprogram/nba/schoolForm/saveLoading',
      subpropertyId: 'subprogram/nba/subpropertyId',
      isRootScreen: 'layout/isRootScreen',
      currentManage: 'auth/manage/currentManage',
    }),
    subpropertyId() {
      return get(this, 'currentManage.subproperty.id', null);
    },
    propertyId() {
      return get(this, 'currentManage.property.id', null);
    },
		isEditing() {
			return !!this.schoolId;
    },
    dynamicRoute() {
      const { name } = this.$route;

      const route = {
        name: 'SubprogramNba',
        params: {
          programId: this.programId,
          subprogramId: this.subprogramId
        }
      };

      if (name === 'SubprogramNbaSchoolTeamEdit') {
        route.name = 'SubprogramNbaSchoolTeamView';
        route.params = { programId: this.programId, subprogramId: this.subprogramId, teamId: this.teamId, tabName: 'summary' };
      }

      return route;
    },

  },

  methods: {
    ...mapActions({
      doAssignSchoolToTeam: 'subprogram/nba/schoolForm/doAssignSchoolToTeam',
      doUpdate: 'school/form/doUpdate',
    }),

    async handleOnSubmitSchool(schoolModel) {
      if (this.isEditing) {
         await this.doUpdate({ 
          id: schoolModel.id,
          data: schoolModel, 
          manage: { 
            subpropertyId: this.subpropertyId, 
            propertyId: this.propertyId, 
            type: 'subporperty'
          },
        });
      } else {        
        await this.doAssignSchoolToTeam({
          teamId: this.teamId, 
          school: schoolModel,
          manage: { 
            subpropertyId: this.subpropertyId, 
            propertyId: this.propertyId, 
            type: 'subporperty'
          }
        });
      }
    },

    doBack(){
      if (this.isRootScreen) {
        this.$router.push({ 
          name: 'SubprogramNba', 
          params: {
            programId: this.programId,
            subprogramId: this.subprogramId
          }
        })
      } else {
        this.$router.go(-1)
      }
    }
  },

  components: {
    [SchoolForm.name]: SchoolForm,
    [SubprogramNbaSchoolFormCard.name]: SubprogramNbaSchoolFormCard
  },
}
</script>
